export const BABEL7_VERSION = '7.20.13';
